import { render } from "./LichenRecordForm.vue?vue&type=template&id=1a673d0c&scoped=true&ts=true"
import script from "./LichenRecordForm.vue?vue&type=script&lang=ts"
export * from "./LichenRecordForm.vue?vue&type=script&lang=ts"

import "./LichenRecordForm.vue?vue&type=style&index=0&id=1a673d0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a673d0c"]])

export default __exports__